var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoatTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.4,
    height: 14.8,
    viewBox: "0 0 63.4 14.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boat-top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.8,14.8c.1-5.2-1.9-9-4.1-13.5a2.1,2.1,0,0,0-3.9,0c-2.1,4.5-4.1,8.4-4.1,13.5H37.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatTop);
export default __webpack_public_path__ + "static/media/boat-top.0dc30a564517ff93ce2c6dd5e9651be2.svg";
export { ForwardRef as ReactComponent };